module.exports = __webpack_public_path__ + "public/images/stands-bg-1@2x.baa74cb8e920cc27655d46a5bcdde5e1.jpg";